import { useEffect, useState } from "react";

import { fetchTasOccurrence, fetchTasOccurrences } from "../api/tasOccurrence";
import { ITasOccurrence } from "../models/tasOccurrence";

export const useTasOccurrence = (chassis: string, tasNumber: string) => {
    const [tasOccurrences, setTasOccurrences] = useState<ITasOccurrence[]>([]);
    const [tasOccurrence, setTasOccurrence] = useState<ITasOccurrence | null>(null);
    
    const [detailsLoading, setDetailsLoading] = useState<boolean>(false);
    const [tasOccurrenceDialog, setTasOccurrenceDialog] = useState<boolean>(false);

    const tasOccurrenceDetails: { label: string, value?: string }[] = [
        { label: "Número", value: tasOccurrence?.tasOccurrenceNumber },
        { label: "Status", value: tasOccurrence?.status },
        { label: "Responsável", value: tasOccurrence?.responsible },
        { label: "Observações", value: tasOccurrence?.details },
        { label: "Assunto", value: tasOccurrence?.tasSubject },
        { label: "Em qual frequência a falha ocorre?", value: tasOccurrence?.failureFrequency },
        { label: "Nome da Peça ou Componente", value: tasOccurrence?.partOrComponentName },
        { label: "Nº da peça VW/MAN", value: tasOccurrence?.partNumber },
        { label: "Procedimentos de diagnóstico e resultados", value: tasOccurrence?.diagnosticAndResults },
        { label: "Qual a reclamação do cliente?", value: tasOccurrence?.customerComment },
        { label: "Em qual situação a falha ocorre?", value: tasOccurrence?.diagnose },
        { label: "O que aconteceu?", value: tasOccurrence?.problemDescription },
        { label: "Reparo/solução dada", value: tasOccurrence?.repair },
    ]

    useEffect(() => {
        getTasOccurrences();
    }, [chassis]);

    useEffect(() => {
        if (chassis && tasNumber) getTasOccurrence();
        else setTasOccurrence(null);
    }, [tasOccurrences, tasNumber]);

    const getTasOccurrences = async () => {
        const data = await fetchTasOccurrences(chassis);
        setTasOccurrences(data);
    }

    const getTasOccurrence = async () => {
        setDetailsLoading(true);
        try {
            const data = await fetchTasOccurrence(chassis, tasNumber);
            setTasOccurrence(data || null);
        } catch (error) {
            console.error('Error fetching tas occurrence:', error);
        } finally {
            setDetailsLoading(false);
        }
    }

    return {
        detailsLoading,
        tasOccurrence,
        tasOccurrences,
        tasOccurrenceDetails,
        tasOccurrenceDialog,
        setTasOccurrenceDialog,
    };
};